<div class="containerStepper">
  <div
    class="singleParamContainer"
    *ngIf="
      singleSelectParas &&
      singleSelectParas.length > 0 &&
      (!multiSelectParaDefinitions || multiSelectParaDefinitions.length === 0)
    "
  >
    <div fxLayout="column" fxLayoutAlign="center none">
      <div *ngFor="let para of singleSelectParas">
        <param-values-editor
          [parameter]="para"
          (parameterValueChange)="parameterValueChanged($event)"
        ></param-values-editor>
      </div>
    </div>
  </div>

  <mat-tab-group
    *ngIf="multiSelectParaDefinitions && multiSelectParaDefinitions.length > 0"
    mat-stretch-tabs="false"
    mat-align-tabs="center"
    animationDuration="0ms"
  >
    <ng-container *ngIf="singleSelectParas && singleSelectParas.length > 0">
      <mat-tab label="Werte" style="padding-top: 10px">
        <div fxLayout="column" fxLayoutAlign="center none">
          <div *ngFor="let para of singleSelectParas">
            <param-values-editor
              [parameter]="para"
              (parameterValueChange)="parameterValueChanged($event)"
            ></param-values-editor>
          </div>
        </div>
      </mat-tab>
    </ng-container>

    <!-- Render tabs for multiSelectParaDefinitions -->
    <ng-container>
      <ng-container *ngFor="let multiSelectPara of multiSelectParaDefinitions">
        <mat-tab label="{{ multiSelectPara.para.Caption || multiSelectPara.para.Name }}">
          <div fxLayout="column" fxLayoutAlign="center none">
            <param-values-editor
              [parameter]="multiSelectPara.para"
              (parameterValueChange)="parameterValueChanged($event)"
            ></param-values-editor>
          </div>
        </mat-tab>
      </ng-container>
    </ng-container>
  </mat-tab-group>

  <div class="buttonContainer">
    <abc-button
      [stylingMode]="'contained'"
      [text]="res.get('ValuesEditorContainer-Cancel')"
      [width]="'110px'"
      style="margin-left: 10px"
      (onClick)="cancel()"
    >
    </abc-button>
    <abc-button
      [stylingMode]="'contained'"
      [text]="res.get('ValuesEditorContainer-Ok')"
      [width]="'110px'"
      (onClick)="apply()"
    >
    </abc-button>
  </div>
</div>
